import React from 'react';
import InputText from 'ROOT/src/components/formElements/InputText';
import Checkbox from 'ROOT/src/components/formElements/TickBox';
import Select from 'ROOT/src/components/formElements/Select';
import Relate from 'ROOT/src/components/formElements/Relate';

import sAction from 'sAction';
import AcmDate from 'ROOT/src/components/formElements/AcmDate';
import AcmDatetime from 'ROOT/src/components/formElements/AcmDatetime';

import CustomLine_orig from 'ROOT/src/components/detailView/CustomLines/CustomLine';
export default class CustomLine extends CustomLine_orig {
    getField(col, data, key) {
        const moduleData = this.props.moduleData;
        const colDef = moduleData.get(col);
        const def = this.props.def;
        let defaultValue = data.get ? data.get(col) : null;
        let className = '';
        const disabled = this.permissions ? colDef.get('readonly') : true;
        let style = null;
        let timelineStyle = null;
        if (def.get && def.get('style') && def.get('style').get && def.get('style').get(col)) {
            style = def.get('style').get(col).toJS();
        }
        let extraClass = '';
        if (def.get && def.get('extraClass') && def.get('extraClass').get && def.get('extraClass').get(col)) {
            extraClass = def.get('extraClass').get(col);
        }
        if (this.props.showError === true && colDef.get('required') === true && ((typeof defaultValue === 'string' && defaultValue.trim() === '') || (!defaultValue && defaultValue !== 0))) {
            extraClass += ' error';
        }
        if (this.props.timeline && this.props.timeline.get('field') === col) {
            if (style == null) {
                style = {};
            }
            style.color = 'white';
            style.backgroundColor = this.props.timeline.get('colors').get(defaultValue);
            timelineStyle = {color: 'white'};
        }

        switch (colDef.get('type')) {
            // TODO přidat další typy
            case 'bool':
                this[col].current = {value: data[key]};

                return (
                    <div
                        className={'customLinesCell '+extraClass}
                        key={key}
                        style={style}>
                        <Checkbox
                            checked={defaultValue || ''}
                            onChange={(e) => {
                                this[col].current.value = e; this.changeVal(e, col);
                            }}
                            disabled={disabled}
                        />
                    </div>
                );
            case 'relate':
                return <Relate
                    key={key}
                    newRecord={false}
                    buttons={[]}
                    containerClassName={'customLinesCell'+extraClass}
                    // inputClassName={"withBorder"}
                    containerStyle={style}
                    callback={(e) => {
                        this.changeVal(e.id, colDef.get('id_name')); sAction.dataSet(this.props.way + '/customData/customLines/lines/' + this.props.keyV + '/' + col, e.name);
                    }}
                    module={colDef.get('module')}
                    data={{
                        value: defaultValue || '',
                    }}
                    updateField = {true}
                />;
            case 'enum':
                const options = sAction.app_strings[colDef.get('options')];

                if (defaultValue === null || defaultValue === undefined) {
                    defaultValue = colDef.get('default');
                }

                return (
                    <div
                        className={'customLinesCell '+extraClass + ' withBorder ' + className}
                        key={key}
                        style={style}
                    >
                        {options[defaultValue] ?? defaultValue}
                    </div>
                );
            case 'currency':
                className = ' alignRight';
                if (!defaultValue && defaultValue !== 0 && defaultValue !== '0') {
                    defaultValue = '';
                } else if (typeof defaultValue === 'string' ) {
                    defaultValue = sAction.formatNumber(parseFloat(defaultValue).toFixed(2), 2, ',', ' ');
                }
                return (
                    <div
                        className={'customLinesCell '+extraClass + ' withBorder ' + className}
                        key={key}
                        style={style}
                    >
                        {defaultValue}
                    </div>
                );
            case 'float':
            case 'decimal':
            case 'int':
                if (!defaultValue && defaultValue !== 0 && defaultValue !== '0') {
                    defaultValue = '';
                } else {
                    defaultValue = Math.round(defaultValue * 100) / 100;
                }

                return (
                    <div
                        className={'customLinesCell '+extraClass + ' alignRight ' + className}
                        key={key}
                        style={style}
                    >
                        {defaultValue}
                    </div>
                );
            case 'date':
                if (!defaultValue || defaultValue === '0000-00-00') {
                    defaultValue = '-';
                } else {
                    defaultValue = defaultValue.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3. $2. $1');
                }
                return (
                    <div
                        className={'customLinesCell '+extraClass + ' ' + className}
                        key={key}
                        style={style}
                    >
                        {defaultValue}
                    </div>
                );
            case 'datetime':
                return (
                    <div
                        className={'customLinesCell acmInputContainer '+extraClass}
                        style={style}
                        key={key}
                    >
                        <AcmDatetime
                            type={'text'}
                            placeholder=' '
                            className="withBorder"
                            disabled={disabled}
                            value={defaultValue || null}
                            myRef={this[col]}
                            onChange={(e) => this.changeVal(e.target.value, col)}
                        />
                    </div>
                );
            case 'id':
            case 'text':
            case 'name':
            case 'varchar':
            default:
                return (<div key={key} className={'customLinesCell ' + extraClass + ' ' + className} style={style}>{defaultValue || ''}</div>);
        }
    }


    render() {
        const data = this.props.data;
        const def = this.props.def;
        const cols = [];
        def.get('fields').toJS().forEachObject((col, key) => {
            cols.push(this.getField(col, data, key));
            if (def.get('switch') && def.get('switch').get(col)) {
                this.doSwitch(col, data.get(col), true);
            }
        });
        const lineButtons = this.props.canEdit ? this.getLineButtons('deleted', {}, cols.length) : (<div className='customLinesCell customLinesCellDelete'></div>);

        return (
            <div className='customLinesRowContainer'>
                {/* {lineButtons}*/}
                {cols}
            </div>
        );
    }
}
